import { apiEndpoints } from '../lib/apiEndpoints/apiEndpoints';
import { useLPMutation } from '../lib/hooks/useLPMutation';
import { useRequestClient } from '../lib/hooks/useRequestClient';

type CampaignSendNudgeMutationParams = {
  campaignId: string;
  userId?: string;
};

export const useCampaignSendNudgeMutation = () => {
  const kyInstance = useRequestClient();

  return useLPMutation<unknown, CampaignSendNudgeMutationParams>(async ({ campaignId, userId }) => {
    const baseUrl = apiEndpoints.getAPIEndpoint('root');
    if (!baseUrl) {
      throw new Error('endpoint "root" is not defined');
    }

    const url = `${baseUrl}/nudges/campaign/${campaignId}/${userId ? `users/${userId}` : 'all'}`;
    if (!kyInstance) {
      throw new Error('Missing RequestClientProvider');
    }

    return await kyInstance.get(url).json();
  });
};
